import { render, staticRenderFns } from "./MailMonitorInfo.vue?vue&type=template&id=56a60e56&"
import script from "./MailMonitorInfo.vue?vue&type=script&lang=js&"
export * from "./MailMonitorInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports